import React, { Component } from 'react';
import './Loader.scss';

const Loader = (props) => {
    return (
        <div className='loader' />
    );
};

export default Loader;



// WEBPACK FOOTER //
// ./application/components/Loader/Loader.jsx